import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://localhost:7008/api";

const publicApi = axios.create({
  baseURL: API_BASE_URL.replace(/\/$/, ""),
  headers: { "Content-Type": "application/json" },
});

export type ContractSignatureMethod = 0 | 1 | 2;

export const ContractSignatureMethodValues = {
  Typed: 0,
  Drawn: 1,
  Either: 2,
} as const satisfies Record<string, ContractSignatureMethod>;

export interface SigningContextResponse {
  operatorBusinessName: string;
  clientFullName: string;
  contractTextHtml: string;
  consumerRightsDisclosure: string;
  allowedSignatureMethod: ContractSignatureMethod;
  alreadySigned: boolean;
  voided: boolean;
  expired: boolean;
  expiresAt: string;
}

export interface SubmitSignatureRequest {
  methodUsed: ContractSignatureMethod;
  typedName?: string | null;
  drawnPngBase64?: string | null;
}

export interface SignatureCompletedResponse {
  signedAt: string;
  integrityHashSha256Prefix: string;
  downloadUrl: string;
}

export const publicContractsApi = {
  getSigningContext: async (token: string): Promise<SigningContextResponse> => {
    const { data } = await publicApi.get<SigningContextResponse>(
      `/public/contracts/sign/${encodeURIComponent(token)}`
    );
    return data;
  },

  submitSignature: async (
    token: string,
    req: SubmitSignatureRequest
  ): Promise<SignatureCompletedResponse> => {
    const { data } = await publicApi.post<SignatureCompletedResponse>(
      `/public/contracts/sign/${encodeURIComponent(token)}`,
      req
    );
    return data;
  },

  downloadSignedPdf: async (token: string, fileName: string): Promise<void> => {
    const res = await publicApi.get(
      `/public/contracts/sign/${encodeURIComponent(token)}/pdf`,
      { responseType: "blob" }
    );
    const blob = res.data as Blob;
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  },
};
